var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollapse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium svg-inline--fa css-vubbuv",
    focusable: "false",
    "aria-hidden": "true",
    role: "img",
    viewBox: "0 0 448 512",
    "data-prefix": "far",
    "data-icon": "angles-left",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.9 388L92.23 252l121.6-136c4.094-4.563 6.125-10.28 6.125-16c0-6.594-2.687-13.16-7.1-17.88C202.1 73.28 186.9 74.12 178.1 83.99L42.14 235.1c-8.187 9.125-8.187 22.88 0 32l135.1 152c8.812 9.875 23.1 10.72 33.87 1.875C221.9 413.1 222.7 397.8 213.9 388zM234.1 235.1c-8.187 9.125-8.187 22.88 0 32l135.1 152c8.812 9.875 23.1 10.72 33.87 1.875c9.906-8.813 10.72-24.03 1.875-33.88L284.2 252l121.6-136c4.094-4.563 6.125-10.28 6.125-16c0-6.594-2.687-13.16-7.1-17.88c-9.874-8.844-25.06-8-33.87 1.875L234.1 235.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.174b0a1c93119b0354f899d9bf267d8c.svg";
export { ForwardRef as ReactComponent };